export const SPS_STATIC_HREF_LANG_MAPPING: Record<
  string,
  { lang: 'de' | 'en'; alternate: { lang: 'de' | 'en'; href: string }; xDefault: string }
> = {
  '/en/news': { lang: 'en', alternate: { lang: 'de', href: '/de/news' }, xDefault: '/en/news' },
  '/de/news': { lang: 'de', alternate: { lang: 'en', href: '/en/news' }, xDefault: '/en/news' },
  '/en/pages/knowledge-center': {
    lang: 'en',
    alternate: { lang: 'de', href: '/de/pages/knowledge-center' },
    xDefault: '/en/pages/knowledge-center',
  },
  '/de/pages/knowledge-center': {
    lang: 'de',
    alternate: { lang: 'en', href: '/en/pages/knowledge-center' },
    xDefault: '/en/pages/knowledge-center',
  },
  '/en/pages/about-us/global-locations': {
    lang: 'en',
    alternate: { lang: 'de', href: '/de/pages/about-us/global-locations' },
    xDefault: '/de/pages/about-us/global-locations',
  },
  '/de/pages/about-us/global-locations': {
    lang: 'de',
    alternate: { lang: 'en', href: '/en/pages/about-us/global-locations' },
    xDefault: '/en/pages/about-us/global-locations',
  },
};
